import * as fromDatatype from '../datatype-library/index';

export class app_login_subject_to_tenant_link_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  message_json: any;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
}

export class app_login_subject_to_tenant_link_audit_trail_RowClass implements app_login_subject_to_tenant_link_audit_trail_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  message_json: any;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  link_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
}
